import React from "react";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  countBadge: {
    backgroundColor: "#767a8a",
    borderRadius: "25px",
    padding: "2px 6px",
    color: "white !important",
    fontSize: "15px",
    fontWeight: "400",
    "-webkit-text-fill-color": "white",
  },
}));

export default function MultiSelect({ title = "", className = "", dataLength = 0, badgeFirst = false }) {
  const { classes } = useStyles();

  return (
    <span style={{ verticalAlign: "middle" }}>
      {badgeFirst ? (
        <>
          <span className={`${classes.countBadge} ${className}`}>{dataLength}</span>&nbsp;{title}
        </>
      ) : (
        <>
          {title}&nbsp;<span className={`${classes.countBadge} ${className}`}>{dataLength}</span>
        </>
      )}
    </span>
  );
}
